import React, { useEffect } from "react";
import * as Styles from "../common/styles/TradeInAem";
import * as Text from "../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { useTradeInAemSelector } from "../../../redux/store";
import Valuation from "../common/valuation/Valuation";
import TradeInAemVehicleResultBlock from "../common/TradeInAemVehicleResultBlock";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { useTradeInAemLabel, useTradeInAemOptionalLabel } from "../../../utils/labels";
import Icon from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import useVehicleValueContainer from "../../../hooks/vehicle-value/useVehicleValueContainer";
import { trackStepVehicleValue } from "../../../utils/tracking";
import ButtonPrimary from "../../../../common-deprecated/components/aem/toyota/ButtonPrimary";
import ButtonTertiary from "../../../../common-deprecated/components/aem/toyota/ButtonTertiary";
import useTradeInPdf from "../../../hooks/useTradeInPdf";
import { TradeInAemVersion } from "../../../utils/constants";
import useTrackingParams from "../../../hooks/useTrackingParams";

const VehicleValueContainer = (): JSX.Element => {
    const csl = useTradeInCsl();
    const expireLabel = useTradeInAemSelector(csl.vehicleQuoteExpirySelector);
    const searchType = useTradeInAemSelector((state) => state.tradeInAemFindVehicle.searchType);
    const tradeInVersion = useTradeInAemSelector((state) => state.tradeInAemUtils.version);
    const pdfLabel = useTradeInAemLabel("tradeInAemVehicleValuePdf");
    const disclaimer = useTradeInAemOptionalLabel("tradeInAemVehicleValueDisclaimer");

    const { showPdfButton, onPrint } = useTradeInPdf();
    const { mainCtaProps } = useVehicleValueContainer();
    const trackingParams = useTrackingParams();
    const isHiddenTradeIn = tradeInVersion === TradeInAemVersion.Hidden;

    useEffect(() => {
        trackStepVehicleValue(trackingParams, searchType);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Styles.Main>
            <Styles.Container>
                <Valuation />
                <TradeInAemVehicleResultBlock />
                <Styles.Actions mt={2} spaceBetween={showPdfButton}>
                    {showPdfButton && (
                        <ButtonTertiary hasIcon onClick={onPrint}>
                            <Icon variant="download" />
                            <Text.Button>{pdfLabel}</Text.Button>
                        </ButtonTertiary>
                    )}

                    {!isHiddenTradeIn && (
                        <ButtonPrimary href={mainCtaProps.href} onClick={mainCtaProps.onClick}>
                            {mainCtaProps.label}
                        </ButtonPrimary>
                    )}
                </Styles.Actions>
                {(!!disclaimer || !!expireLabel) && (
                    <Styles.Disclaimer>
                        {!!disclaimer && <p>{disclaimer}</p>}
                        {!!expireLabel && (
                            <p>
                                <strong>{expireLabel}</strong>
                            </p>
                        )}
                    </Styles.Disclaimer>
                )}
            </Styles.Container>
        </Styles.Main>
    );
};
export default VehicleValueContainer;
